import { Hotels } from "services";
import { ThunkType } from "store/types";
import { IHotelInfoResult } from "types";

import { setHotelPriceInfo } from "./slice";
import { selectHotelPriceInfo } from "./selectors";

export const getHotelPriceInfoThunk =
  (
    hotelID: string,
    country: string
  ): ThunkType<Promise<IHotelInfoResult | undefined>> =>
  async (dispatch, getState) => {
    try {
      const hotelInfo = selectHotelPriceInfo(getState())(hotelID);

      if (hotelInfo) {
        return Promise.resolve(hotelInfo);
      }

      const hotelsService = new Hotels(country, "");
      const response = await hotelsService.info(hotelID);

      if (response) {
        dispatch(setHotelPriceInfo(response));
        return Promise.resolve(response);
      }

      return Promise.resolve(undefined);
    } catch (error) {
      return Promise.reject(error);
    }
  };
